// Always use relative /api path - works on any domain (preview, production, custom domain)
export const API = '/api';
